import "bootstrap/js/dist/util"
import "bootstrap/js/dist/collapse"
import "bootstrap/js/dist/dropdown"
import "jquery-match-height"
import "slick-carousel"
import Scroller from "./components/scroller"
import Forms from "./components/forms"

class App {
  static init() {
    new Scroller().watch()
    new Forms().init()

    $(".types-carousel .slick-slider").slick({
      slidesToShow: 3,
      infinite: false,
      dots: true,
      arrows: false,
      responsive: [
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 630,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    })

    $(".rich-content .slick-slider.main").slick({
      slidesToShow: 1,
      arrows: false,
      dots: false,
      adaptiveHeight: true,
      asNavFor: ".rich-content .slick-slider.thumbs"
    })

    $(".rich-content .slick-slider.thumbs").slick({
      slidesToShow: 4,
      arrows: false,
      dots: true,
      asNavFor: ".rich-content .slick-slider.main",
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    })

    const SVG_ARROW =
      '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><circle class="arrow-slider-circle" cx="12" cy="12" r="11.5" fill="none" stroke="#8C8C8C"/><path class="arrow-slider-shape" fill="#8C8C8C" d="M10.509 12l3.308-3.025a.537.537 0 0 0 0-.808.667.667 0 0 0-.884 0l-3.75 3.429a.537.537 0 0 0 0 .808l3.75 3.429c.244.223.64.223.884 0a.537.537 0 0 0 0-.808L10.509 12z"/></svg>'

    $(".trustpilot-carousel .slick-slider").slick({
      slidesToShow: 3,
      infinite: false,
      prevArrow: `<button type="button" class="slick-prev">${SVG_ARROW}</button>`,
      nextArrow: `<button type="button" class="slick-next">${SVG_ARROW}</button>`,
      responsive: [
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 630,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    })

    $(".navbar-toggler").on("click", e => {
      $(e.currentTarget).toggleClass("is-active")
      $(".navbar").toggleClass("mobile-active")
      $("body").toggleClass("overflow-hidden")
    })
  }
}

App.init()
